export const state = () => ({
  loading: true,
})

export const getters = {
  isLoading(state) {
    return state.loading
  },
}

export const mutations = {
  SET_LOADING(state, value) {
    state.loading = value
  },
}

export const actions = {
  stopBusyState({ commit }) {
    commit('SET_LOADING', false)
  },
  startBusyState({ commit }) {
    commit('SET_LOADING', true)
  },
}
